import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Box, Stack, Button} from '@salesforce/retail-react-app/app/components/shared/ui'

const LINES = 6

function getIOSVersion() {
    const ua = navigator.userAgent
    const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1

    if (/iPhone|iPad|iPod/.test(ua) || isIPadOS) {
        const match = ua.match(/OS X (\d+)_?(\d+)?_?(\d+)?/)
        if (match) {
            return {
                major: parseInt(match[1], 10),
                minor: parseInt(match[2] || '0', 10),
                patch: parseInt(match[3] || '0', 10)
            }
        }

        return null
    }

    return null
}

const Description = ({description}) => {
    const intl = useIntl()
    const textRef = useRef(null)
    const [rendered, setRendered] = useState(true)
    const [isExpanded, setIsExpanded] = useState(false)
    const [isTruncated, setIsTruncated] = useState(false)
    const [isIOS15, setIsIOS15] = useState(false)

    useEffect(() => {
        setRendered(false)
        setIsExpanded(false)
    }, [description])

    useEffect(() => {
        if (textRef.current && !rendered) {
            const lineHeight = parseInt(window.getComputedStyle(textRef.current).lineHeight)
            const maxHeight = lineHeight * LINES
            setIsTruncated(textRef.current.scrollHeight > maxHeight)
            setRendered(true)
        }
    }, [description, rendered])

    useEffect(() => {
        const validation = (() => {
            if (typeof navigator === 'undefined') return false

            const version = getIOSVersion()
            if (version && version?.major === 10 && version?.minor === 15) {
                return true
            }

            return false
        })()

        setIsIOS15(validation)
    }, [])

    return (
        description && (
            <Stack className="product-description" gap="10px">
                <Box
                    ref={textRef}
                    noOfLines={isExpanded ? undefined : isIOS15 ? undefined : LINES}
                    maxHeight={isExpanded ? undefined : isIOS15 ? '75px' : undefined}
                    overflow={isIOS15 && rendered ? 'hidden' : undefined}
                    fontSize="14px"
                    lineHeight="22px"
                    letterSpacing="0.07px"
                    fontWeight="300"
                    color="black"
                    sx={{
                        p: {
                            fontSize: '14px',
                            lineHeight: '22px',
                            letterSpacing: '0.07px',
                            fontWeight: '300',
                            color: 'black'
                        }
                    }}
                    dangerouslySetInnerHTML={{
                        __html: description
                    }}
                />

                {isTruncated && (
                    <Box>
                        <Button
                            onClick={() => setIsExpanded(!isExpanded)}
                            variant="textUnderline"
                            textDecoration="none"
                            color="gray.650"
                            fontSize="14px"
                            fontWeight="300"
                            lineHeight="22px"
                            letterSpacing="0.07px"
                        >
                            {isExpanded
                                ? intl.formatMessage({
                                      id: 'read.less',
                                      defaultMessage: 'Read Less'
                                  })
                                : intl.formatMessage({
                                      id: 'read.more',
                                      defaultMessage: 'Read More'
                                  })}
                        </Button>
                    </Box>
                )}
            </Stack>
        )
    )
}

Description.propTypes = {
    description: PropTypes.string
}

export default Description
